<template>
  <div style="width:90%">
		<div class="container_body">
      <header class="header_nav">
        <el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
          <el-form-item label="商品ID" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsId" placeholder="请输入商品ID"></el-input>
					</el-form-item>
          <el-form-item label="商品名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsName" placeholder="请输入商品名称"></el-input>
					</el-form-item>
          <el-form-item label="预约状态" class='tiny' cleartable>
            <el-select clearable  v-model="searchInfo.status" placeholder="请选择状态"
						style="width:150px;">
							<el-option v-for="item in statusList" :key="item.value" :label="item.name"
							:value="item.value"></el-option>
						</el-select>
					</el-form-item>
          <el-form-item>
            <template>
              <el-button type="primary" @click="searchStore">查询</el-button>
							<el-button @click="empty">清空</el-button>
              <el-button type="primary" @click="dialogVisibleFun()">抢购商品设置</el-button>
            </template>
          </el-form-item>
        </el-form>
      </header>
    </div>
    <!-- 设置为抢单商品的表格 -->
    <el-table
      :data="storeList"
      stripe style="width: 100%;" :header-cell-style="headClass"
      v-loading="loading"
			element-loading-text="拼命加载中" 
      element-loading-spinner="el-icon-loading"
     >
      <el-table-column
        prop="goodsId"
        label="商品ID"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="goodsName"
        label="商品名称"
        align="center"
        width="150"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="price"
        align="center"
        label="单价">
      </el-table-column>
      <el-table-column
        prop="subscribePrice"
        label="活动价"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        label="预约状态"
        align="center"
        width="100">
        <template slot-scope="scope">
          <span style="margin-left: 10px" v-if="scope.row.status == 0">未开始</span>
          <span style="margin-left: 10px" v-if="scope.row.status == 1">预约中</span>
          <span style="margin-left: 10px" v-if="scope.row.status == 2">已结束</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="beginTime"
        label="开始时间"
        align="center"
        :show-overflow-tooltip="true"
        width="150">
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="结束时间"
        align="center"
        :show-overflow-tooltip="true"
        width="150">
      </el-table-column>
      <el-table-column
        prop="limitCnt"
        label="最多参与数"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="limitLowCnt"
        label="最少参与数"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="chooseCnt"
        label="抢中人数"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        
         label="操作"  fixed="right"
        align="center"
        width="100">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status == '0'" type="text" size="small"  @click="dialogVisibleFun(scope.row)">编辑</el-button>
          <el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="recordsList(scope.row.id)">预约记录</el-dropdown-item>
							<el-dropdown-item @click.native="delStore(scope.row)">删除</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin: 20px 0px 20px;" background :current-page="page.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="total"
			@size-change="handleSizeChange">
		</el-pagination>
    <!-- 新增抢单商品 -->
    <el-dialog
      :title="dialogVisibleFunName"
      :visible.sync="dialogVisible"
      width="50%">
      <div class="app-container" style="text-align: center;">
        <el-form size="medium" :model="updateInfo" ref="updateInfo" status-icon :rules="rules">
          <div style="display: flex;align-items: center;justify-content: flex-start;" >
            <el-form-item label="商品名称" style="width: 300px; position: relative;">
								<el-input type="text"  v-model="goodsName"
									placeholder="请输入商品名称(搜索条件)" @input="inputHandler" clearable />
                <div class="searchBox" v-show="isSearchShow">
                  <p v-for="item in accountList" :key="item.id" @click="selectStore(item.id,item.goodsName)">{{ item.goodsName }}</p>
                </div>
						</el-form-item>
          </div>
          <div style="display: flex;align-items: center;">
            <el-form-item label="店铺名称" style="margin-right: 20px;" >
              <el-input type="text" clearable v-model="storeInfo.storeName" disabled/>
						</el-form-item>
						<el-form-item label="供应商名称" >
              <el-input type="text" clearable v-model="storeInfo.supplierName" disabled/>
						</el-form-item>
					</div>
          <div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="商品单价" >
              <el-input type="text" clearable v-model="storeInfo.price" disabled/>
						</el-form-item>
					</div>
          <div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="活动价格" prop="price">
              <el-input type="text" clearable v-model="updateInfo.price"
									placeholder="设置活动价格" />
						</el-form-item>
					</div>
          <div style="display: flex;align-items: center;justify-content: space-between;">
            <el-form-item label="活动时间">
              <el-col :span="11">
                <el-date-picker
                  v-model="updateInfo.dateValue"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  align="right">
                </el-date-picker>
              </el-col>
            </el-form-item>
					</div>
          <div style="display: flex;align-items: center;">
            <el-form-item label="最低人数" prop="minNum">
              <el-input type="text" v-model="updateInfo.minNum" autocomplete="off" placeholder="少于此人数活动取消"  style="width: 200px; margin-right: 20px"></el-input>
            </el-form-item>
            <el-form-item label="最多人数" prop="maxNum">
              <el-input type="text" v-model="updateInfo.maxNum" autocomplete="off" placeholder="达到此人数立即结束活动" style="width: 200px"></el-input>
            </el-form-item>
          </div>
          <div style="display: flex;align-items: center;">
            <el-form-item label="抢中人数" prop="robNum">
              <el-input v-model="updateInfo.robNum" autocomplete="off" type="text" style="width: 100px;"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="dialogVisibleFunName == '设置抢购商品'" type="primary" @click="updateRobOrder('updateInfo')">确 定</el-button>
        <el-button v-if="dialogVisibleFunName == '编辑抢购商品'" type="primary" @click="editRobOrder">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 预约记录 -->
    <el-dialog
      title="预约记录"
      :visible.sync="dialogVisibleRecord"
      width="70%">
      <el-form :inline="true" class="demo-form-inline" :model="searchRecordsInfo" style="margin: 20px 0px 0px 20px;">
          <el-form-item label="用户ID" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchRecordsInfo.userId" placeholder="请输入用户ID"></el-input>
					</el-form-item>
          <el-form-item label="用户名" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchRecordsInfo.userName" placeholder="请输入用户名"></el-input>
					</el-form-item>
          <el-form-item label="预约状态" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchRecordsInfo.status" placeholder="请输入预约状态"></el-input>
					</el-form-item>
          <el-form-item>
            <template>
              <el-button type="primary" @click="searchRecordsData">查询</el-button>
							<el-button @click="emptyRecords">清空</el-button>
            </template>
          </el-form-item>
        </el-form>
      <div class="app-container" style="text-align: center;">
        <el-table :data="recordsData"  style="width: 100%">
          <el-table-column property="userId" fixed label="用户ID" align="center"></el-table-column>
          <el-table-column property="userName" fixed label="用户名" align="center"></el-table-column>
          <el-table-column property="subscribeAmount" label="预约金额" align="center"></el-table-column>
          <el-table-column property="status" label="预约状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">已预约</span>
              <span v-if="scope.row.status === 1">已完成</span>
              <span v-if="scope.row.status === 2">已取消</span>
            </template>
          </el-table-column>
          <el-table-column property="createTime" label="预约时间" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column property="pairTime" label="抢购预约成功时间" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="isChoose" label="是否抢中" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isChoose === false">否</span>
              <span v-if="scope.row.isChoose === true">是</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="isCheck" label="是否设置必中" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isCheck === false">否</span>
              <span v-if="scope.row.isCheck === true">是</span>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination  background :current-page="page1.pageNum"
            @current-change="pageChangeRecords" layout="total, sizes, prev, pager, next, jumper" :total="recordsTotal"
            @size-change="handleSizeChangeRecords" :page-sizes="[6, 12, 18, 24]">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    var validateMinNum = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入最低人数'));
      }else if (value > Number(this.updateInfo.maxNum) && this.updateInfo.maxNum != '') {
          callback(new Error('不能大于最多人数'));
          console.log( Number(this.updateInfo.maxNum))
      }else if (value < Number(this.updateInfo.robNum)){
        console.log(value)
        console.log(this.updateInfo.robNum)
        callback(new Error('不能小于抢中人数'));
      }else {
        callback();
      }
    };
    var validateMaxNum = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入最多人数'));
      }else if (value < Number(this.updateInfo.minNum)) {
          callback(new Error('不能小于最低人数'));
      }else {
        callback();
      }
    };
    var validateRobNum = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入选中人数'));
      }else if (value > Number(this.updateInfo.minNum)) {
          console.log(value)
          console.log(this.updateInfo.minNum)
          callback(new Error('不能大于最低人数'));
      }else {
        callback();
      }
    };
    var validatePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入活动价格'));
      }else if (value > Number(this.storeInfo.price.slice(0, -1)) && this.storeInfo.price != '' ) {
          callback(new Error('活动价格不能大于商品单价'));
      }else {
        callback();
      }
    };
    return {
      searchInfo: {},
      accountList:[],
      dialogVisible: false,
      dialogVisibleFunName: '',
      dialogVisibleRecord: false,
      storeID:'',
      loading:false,
      goodsName:'',
      id: '',
      updateInfo:{
        price:'',
        dateValue:'',
        minNum:'',
        maxNum:'',
        robNum:'',
      },
      storeInfo:{
        price: '',
        storeName: '',
        supplierName:'',
        supplierId:'',
        goodsId:'',
      },
      isSearchShow: false,
      isBtnLoading: false,
      storeList: [],
      page: {
					pageNum: 1,
					pageSize: 10
			},
      page1: {
					pageNum: 1,
					pageSize: 6
			},
      total: null,
      statusList: [
        {
          value: '0',
          name: '未开始'
        },
        {
          value: '1',
          name: '预约中'
        },
        {
          value: '2',
          name: '已结束'
        },
      ],
      rules: {
        minNum: [
            { validator: validateMinNum, trigger: 'blur' }
          ],
        maxNum: [
            { validator: validateMaxNum, trigger: 'blur' }
          ],
        robNum: [
            { validator: validateRobNum, trigger: 'blur' }
          ],
        price: [
            { validator: validatePrice, trigger: 'blur' }
          ],
        },
      pickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近两天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 2);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 3);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }],
          disabledDate(time) {
              return time.getTime() < Date.now() - 8.64e7;
          },
          
      },
      recordsData: [],
      recordsID: '',
      recordsTotal: 0,
      searchRecordsInfo:{},
    };
  },
  watch: {
    recordsID(newValue) {
      this.getRecordsList()
    },
  },
  methods:{
    dialogVisibleFun(row) {
        this.goodsName = ''
        this.updateInfo = {
          price:'',
          dateValue:'',
          minNum:'',
          maxNum:'',
          robNum:'',
        }
        this.storeInfo = {
          price: '',
          storeName: '',
          supplierName:'',
          supplierId:'',
          goodsId:'',
        }
				this.dialogVisibleFunName = "设置抢购商品"
				this.dialogVisible = true
				if (row) {
					this.dialogVisibleFunName = "编辑抢购商品"
          console.log(row.id)
          this.id = row.id
          this.goodsName = row.goodsName
          this.storeInfo = {
            price: row.price,
            storeName: row.storeName,
            supplierName: row.supplierName,
            supplierId: row.supplierId,
            goodsId: row.goodsId,
          },
          this.updateInfo = {
            price:row.subscribePrice,
            dateValue:[row.beginTime, row.endTime],
            minNum:row.limitLowCnt,
            maxNum:row.limitCnt,
            robNum:row.chooseCnt,
          }
				}
		},
    inputHandler () {
      let data = {
        goodsName: this.goodsName,
      }
      this.isSearchShow = true
      if(this.goodsName === ''){
        this.isSearchShow = false
      }
      this.$api.searchgoodList(data).then((res) => {
        if (res.state == 'success') {
          this.accountList=res.data
          console.log(res.data);
        }
      })
    },
    selectStore(id,name) {
      console.log('----',id,name)
      this.goodsName = name
      this.storeID = id
      this.isSearchShow = false
      this.$api.storeGoodsFindById(id).then(res => {
        if (res.state == 'success') {
          res=JSON.parse(this.$decrypt(res.data))
          this.storeInfo.price = res.data.price+'￥'
          this.storeInfo.storeName = res.data.storeName
          this.storeInfo.supplierName = res.data.supplierName
          this.storeInfo.supplierId = res.data.supplierId
          this.storeInfo.goodsId = res.data.id
        }
      })
    },
    updateRobOrder(formName) {
      let data = {
        goodsId: this.storeID,
        supplierId: this.storeInfo.supplierId,
        price: this.storeInfo.price.slice(0, -1),
        subscribePrice: this.updateInfo.price,
        beginTime: this.updateInfo.dateValue[0],
        endTime: this.updateInfo.dateValue[1],
        limitCnt: this.updateInfo.maxNum,
        limitLowCnt : this.updateInfo.minNum,
        chooseCnt: this.updateInfo.robNum
      }
      console.log(data)
      this.$api.addSubscribe(data).then(res => {
        if(res.state == "success"){
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.dialogVisible = false
          this.getList()
        }else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    editRobOrder() {
      this.dialogVisible = false
      console.log(this.id,this.updateInfo,this.storeInfo)
      let data = {
        id: this.id,
        goodsId: this.storeInfo.goodsId,
        supplierId: this.storeInfo.supplierId,
        price: this.storeInfo.price,
        subscribePrice: this.updateInfo.price,
        beginTime: this.updateInfo.dateValue[0],
        endTime: this.updateInfo.dateValue[1],
        limitCnt: this.updateInfo.maxNum,
        limitLowCnt : this.updateInfo.minNum,
        chooseCnt: this.updateInfo.robNum
      }
      this.$api.updateSubscribe(data).then(res => {
        if(res.state == "success") {
          console.log(res)
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.getList()
        }else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    delStore(row) {
      this.$confirm('是否删除此抢购商品？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.$api.delreSubscribe(row.id).then(res => {
            if(res.state == 'success'){
              this.$message({
                type: 'success',
                message: res.message
              });
              this.getList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    getList() {
      this.loading = true
      this.$api.getSubscribe(this.page).then(res => {
        if(res.state == 'success'){
          this.storeList = res.data.list
          this.total = res.data.total
          this.loading = false
        }
      })
    },
    headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
		},
    pageChange(val) {
      this.page.pageNum = val
      this.getList()
    },
    pageChangeRecords(val) {
      this.page1.pageNum = val
      this.getRecordsList()
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.getList()
    },
    handleSizeChangeRecords(val) {
      this.page1.pageSize = val
      this.getRecordsList()
    },
    searchStore() {
      let obj = {
        pageNum: this.page.pageNum,
        pageSize:this.page.pageSize
      }
      let data = Object.assign(this.searchInfo,obj)
      this.$api.getSubscribe(data).then(res => {
        this.storeList = res.data.list
        this.total = res.data.total
      })
    },
    empty() {
      this.searchInfo = {}
    },
    getRecordsList() {
      let data = {
        subGoodsId: this.recordsID, 
        pageNum: this.page1.pageNum,
        pageSize: this.page1.pageSize
      }
      this.$api.getSubscribeRecordList(data).then(res => {
        console.log(res.data)
        if(res.state == 'success'){
          this.recordsData = res.data.list
          this.recordsTotal = res.data.total
        }
      })
    },
    recordsList(id) {
      this.recordsID = id
      this.dialogVisibleRecord = true
      this.searchRecordsInfo = {}
    },
    searchRecordsData() {
      let obj = {
        subGoodsId: this.recordsID, 
        pageNum: this.page1.pageNum,
        pageSize: this.page1.pageSize
      }
      let data = Object.assign(this.searchRecordsInfo,obj)
      this.$api.getSubscribeRecordList(data).then(res => {
        console.log(res.data)
        if(res.state == 'success'){
          this.recordsData = res.data.list
          this.recordsTotal = res.data.total
        }
      })
    },
    emptyRecords() {
      this.searchRecordsInfo = {}
    },
  },
  created() {
    this.getList()
    console.log(new Date())
  },
}
</script>
<style lang="less">
.searchBox {
  position: absolute;
  top: 50px;
  left: 0;
  z-index: 99;
  width: 232px;
  height: 200px;
  background: #fff;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  overflow: auto;
}

.searchBox::-webkit-scrollbar {
  width: 8px; /* 滚动条宽 */
}

.searchBox::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.searchBox::-webkit-scrollbar-thumb {
  background-color: #c4c2c2; /* 滚动滑块颜色 */
  border-radius: 4px; /* 滚动条滑块圆角 */
}

.searchBox::-webkit-scrollbar-thumb:hover {
  background-color: #939292; /* 鼠悬停时滚动条滑颜色 */
}
</style>